/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class HomepageService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Redirect to organization or login
     * Redirects the user to their last visited organization or to the login page if not authenticated.
     * @returns void
     * @throws ApiError
     */
    redirectToLastVisitedOrganization({ organizationContext, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/', cookies: {
                'organizationContext': organizationContext,
            }, errors: {
                307: `Redirects to the appropriate page.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=HomepageService.js.map